import { createFileRoute } from '@tanstack/react-router';
import { PerformanceReviewForm } from '@/components/company/performance/performance-review-form';

export const Route = createFileRoute('/(app)/company/performance-review/$employeeId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { employeeId } = Route.useParams();
  const employeeIdNum = Number(employeeId);

  if (isNaN(employeeIdNum)) {
    return <div>Invalid employee ID</div>;
  }

  return <PerformanceReviewForm employeeId={employeeIdNum} />;
}
